module.exports = __webpack_public_path__ + "static/media/licensing.6b4975cc.png";